import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../utils/removeKeys';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
  ButtonGroup is a simple stateless function component that will render a UL list based on the children objects
  passed by props.
 **/

const ButtonGroup = (props) => {
  const { children, alignment = '', breakPoint, reverseButtonOrderOnMobile = false, ...rest } =
  removeKeys(props, ['classes']);
  const menuList = React.Children.map(children, item => {
    return (<li {...resolve(props, breakPoint)}>{item}</li>);
  });

  return (
    <ul {...rest} {...resolve(props, 'buttonGroup', alignment,
      reverseButtonOrderOnMobile ? 'reverseButtonOrderOnMobile' : '')} {...resolveTestId(props)} >
      {menuList}
    </ul>
  );
};

ButtonGroup.propTypes = {
  /** child nodes to render inside button group. */
  children: PropTypes.node.isRequired,
  /** sets alignment of child objects. */
  alignment: PropTypes.oneOf(['left', 'center', 'right']),
  /** Breakpoint Class to be added **/
  breakPoint: PropTypes.oneOf(['mediaSmall', 'mediaMedium', 'mediaLarge', 'mediaAll']),
  /** Available Style Keys. */
  style: PropTypes.shape({
    /** Main style for the button group. */
    buttonGroup: PropTypes.object,
    /** Secondary style applied based on button alignment. */
    left: PropTypes.object,
    /** Secondary style applied based on button alignment. */
    center: PropTypes.object,
    /** Secondary style applied based on button alignment. */
    right: PropTypes.object
  })
};

ButtonGroup.defaultProps = {
  alignment: 'right'
};

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
